import { Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useModal, usePage, useResource, useToast } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { APIS, URLS, SF_VHCL_MKER_MGMT_INFO } from "./services/OsciVhclMkerMgmtService";

/*
 * Vehicle Maker Registration
 * !== 차량 제조사 등록 ==!
 */
export const OSCI0105004S = (props: any) => {
    const {} = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const toast = useToast();
    const [params] = useSearchParams();
    const bsopClsfCd = params.get("bsopClsfCd");

    const form = {
        vhclMkerMgmtInfo: useForm({
            defaultSchema: SF_VHCL_MKER_MGMT_INFO,
        }),
    };

    const fetch = {
        saveVhclMkerInfo: useFetch({
            api: (data: any) => APIS.saveVhclMkerInfo(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00069",
                    close: false,
                    onConfirm: () => {
                        navigate(URLS.osci0105006q + "/" + form.vhclMkerMgmtInfo.getValue("vhclMkerCd"));
                    },
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00035" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),

        getVhclMkerCheck: useFetch({
            api: (data: any) => APIS.getVhclMkerCheck(data),
            enabled: false,
            onSuccess: (data) => {
                if (!data.vhclMkerDuplCheck.content) {
                    form.vhclMkerMgmtInfo.clearErrors("vhclMkerCd");
                } else {
                    form.vhclMkerMgmtInfo.setError("vhclMkerCd", {
                        message: t("msg.osc.00128", { 0: form.vhclMkerMgmtInfo.getValue("vhclMkerCd") }), // Please check your TIN. !== TIN을 조회해주세요. ==!
                        type: "error",
                    });
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const handler = {
        // Vehicle Maker Duplicate Check !== 차량 제조사 중복 체크 ==!
        saveVhclMkerInfo: () => {
            if (!comnUtils.isEmpty(form.vhclMkerMgmtInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.vhclMkerMgmtInfo.handleSubmit(
                () => {
                    const data = form.vhclMkerMgmtInfo.getValues();
                    modal.openModal({
                        content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.saveVhclMkerInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
        checkVhclMker: () => {
            const vhclMkerCd = form.vhclMkerMgmtInfo.getValue("vhclMkerCd");
            if (vhclMkerCd) {
                fetch.getVhclMkerCheck.fetch(vhclMkerCd);
            } else {
                form.vhclMkerMgmtInfo.clearErrors("vhclMkerCd");
            }
        },

        setVhclMkerCdChange: () => {
            const vhclMkerCd = form.vhclMkerMgmtInfo.getValue("vhclMkerCd");

            if (!comnUtils.isEmpty(vhclMkerCd)) {
                form.vhclMkerMgmtInfo.setError("vhclMkerCd", {
                    message: "msg.osc.00093",
                    type: "error",
                });
            }
        },
    };

    useEffect(() => {}, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.vhclMkerMgmtInfo.schema.vhclMkerCd}
                                rightButton={{
                                    icon: "search",
                                    onClick: () => {
                                        handler.checkVhclMker();
                                    },
                                }}
                                onChange={() => {
                                    handler.setVhclMkerCdChange();
                                }}
                                maxLength={5}
                            />
                            <Group.Control {...form.vhclMkerMgmtInfo.schema.vhclMkerNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.vhclMkerMgmtInfo.schema.loclYn} />
                            <Group.Control {...form.vhclMkerMgmtInfo.schema.useYn} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button
                        role={"list"}
                        onClick={() => {
                            navigate(`${URLS.osci0105003q}`);
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.saveVhclMkerInfo} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
